import { infiniteQueryOptions } from '@tanstack/react-query'
import getOrderList from '../api/get-order-list'

export const ORDER_LIST_ROOT_QUERY_KEY = ['orders'] as const

export const getOrderListQueryKey = (address: string, serviceIds: string[]) =>
  ['orders', address, serviceIds.join(',')] as const

export const getOrderListQueryOptions = (address: string, serviceIds: string[]) =>
  infiniteQueryOptions({
    queryKey: getOrderListQueryKey(address, serviceIds),
    queryFn: ({ pageParam }) => getOrderList({ after: pageParam, address, serviceIds }),
    initialPageParam: null as string | null,
    getNextPageParam: lastPage => lastPage.pageInfo.endCursor,
    staleTime: 10_000,
  })
